import styled from 'styled-components'

const TableCell = styled.div`
  width: 100%;
  font-size: ${props => (props.fontSize || '13')}px;
`

export default TableCell
